import React, { useState } from 'react'
import { minimumPriceValidator } from 'modules/utils/validators'
import { Form, Input, InputNumber, Switch } from 'antd'

import './index.styl'
import SingleDatePicker from '../../../../Header/DetailsFields/SingleDatePicker'

const { Item } = Form

const ItemTicketItems = ({ namePrefix, currentEventDetails, categoryData, form }) => {
  const [isEarlyBird, setIsEarlyBird] = useState(categoryData?.hasEarlyBird || false)
  const [earlyBirdDate, setEarlyBirdDate] = useState(categoryData?.earlyBirdDate || '')
  const [availableTicket, setAvailableTicket] = useState(form.getFieldValue('showAvailableTickets') || false)

  const availableTicketHandler = () => {
    setAvailableTicket(!availableTicket)
    // form.setFieldsValue({
    //  showAvailableTickets: !availableTicket,
    // })
  }
  const onCheckEarlyBird = () => setIsEarlyBird(!isEarlyBird)
  return (
    <>
      <div className='topField itemTicketItemsWrapper'>
        <div className='inputFields'>
          <Item
            rules={[{ required: true, message: 'Enter Ticket Category Name' }]}
            name={[namePrefix, 'name']}
            label='Ticket Category Name'
          >
            <Input placeholder='Food, drink, t-shirt, etc.' className='inputName' />
          </Item>
          <div className='priceQuantityWrapper'>
            <div className='mobileFlex'>
              <Item
                name={[namePrefix, 'price']}
                label='Ticket Price'
                rules={[
                  { required: true, message: 'Enter price' },
                  minimumPriceValidator,
                ]}
              >
                <InputNumber placeholder='0' className='price' min={0} />
              </Item>
              <Item
                rules={[
                  { required: true, message: 'Enter quantity' },
                  { type: 'number', max: 100000, message: 'Quantity cannot exceed 100 000' },
                  {
                    validator: (_, value) =>
                      Number.isInteger(value) ? Promise.resolve() : new Promise((resolve, reject) => {
                        reject(new Error('Quantity must be an integer!'))
                      }),
                  },
                ]}
                name={[namePrefix, 'quantity']}
                label='Tickets Quantity'
              >
                <InputNumber
                  className='quantity'
                  placeholder='0'
                  min={0}
                />
              </Item>
            </div>
          </div>
        </div>
        <Item
          rules={[{ required: true, message: 'Enter Additional Info' }]}
          name={[namePrefix, 'description']}
          label='Additional Info'
          className='additionalInfoItem'
        >
          <Input className='additionalInfo' />
        </Item>
      </div>
      <div className='radioItemField'>
        <Item
          name={[namePrefix, 'showAvailableTickets']}
          valuePropName='checked'
          className='item'
          initialValue={availableTicket}
        >
          <Switch onChange={availableTicketHandler} defaultChecked={availableTicket} />
        </Item>
        <div className='text'>Show available tickets</div>
      </div>
      <div className='radioItemField earlyBirdDateItem'>
        <Item
          name={[namePrefix, 'hasEarlyBird']}
          className='item'
          valuePropName='checked'
        >
          <Switch onChange={onCheckEarlyBird} defaultChecked={isEarlyBird} />
        </Item>
        <div className='text'>Early Bird Special</div>
      </div>
      {isEarlyBird && (
        <div className='earlyBirdFieldsWrapper'>
          <SingleDatePicker label='Early Bird' namePrefix={namePrefix} nameText='earlyBirdDate' fromDate={earlyBirdDate} form={form} setFromDate={setEarlyBirdDate} title='Early Bird Date' />
          <Item
            name={[namePrefix, 'earlyBirdPrice']}
            dependencies={[[namePrefix, 'price']]}
            label='Price'
            rules={[
              { required: true, message: 'Enter price' },
              minimumPriceValidator,
            ]}
            className='earlyBirdPrice'
          >
            <InputNumber placeholder='0' min={0} />
          </Item>
        </div>
      )}
    </>
  )
}

export default ItemTicketItems
